import { render, staticRenderFns } from "./FlashText.vue?vue&type=template&id=63ba52c7&scoped=true&"
import script from "./FlashText.vue?vue&type=script&lang=ts&"
export * from "./FlashText.vue?vue&type=script&lang=ts&"
import style0 from "./FlashText.vue?vue&type=style&index=0&id=63ba52c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ba52c7",
  null
  
)

export default component.exports